export default {
    en: {
        enterYourTextHere: 'Enter your text here',
        loading: "Loading",
        loadingPage: "Loading page...",
        previous: "Previous",
        next: "Next",
        fetchingSurvey: "Fetching survey...",
        completingSurvey: "Completing survey...",
        registerNow: "Register Now",
        startSurvey: "Start Survey",
        redirectMessage: "You will automatically be redirected back to your dashboard in {countDown} seconds...",
        edit: 'Edit',
        delete: 'Delete',
        likeThisPost: 'Like this post',
        upVoteThisPost: 'Up vote this post',
        saveAndClose: 'Save and close',
        close: 'Close',
        cancel: 'Cancel',
        editingMessage: 'Editing message',
        showMore: 'Show more',
        showLess: 'Show less',
        option: 'Option',
        percentage: 'Percentage',
        count: 'Count',
        label: 'Label',
        pleaseSelectAnswer: 'Please select an answer',
        pleaseSpecify: 'Please specify',
        enterEmail: 'Enter email address here',
        enterNumber: 'Enter number here',
        enterPhone: 'Enter phone number here',
        mediaAppearsHere: 'Media appears here once uploaded',
        takePart: 'Take Part',
        continue: 'Continue',
        view: 'View',
        sendWhatsAppInvite: 'Send WhatsApp invite',
        currentlyUnavailable: 'Currently unavailable',
        seeWhatsApp: 'See WhatsApp',
        viewFinalResults: 'View Final Results',
        draft: 'Draft',
        upNext: 'Up Next',
        completed: 'Completed',
        forum: 'Forum',
        pinnedToDashboard: 'This forum is pinned to participant portal dashboard',
        newLabel: 'New',
        aiAnalysisEnabled: 'AI analysis enabled',
        partOfSequence: 'Part of a sequence',
        dateClosed: 'Date Closed:',
        participants: 'Participants',
        noMobileNumber: 'No mobile number found, please add one in settings',
        viewResults: 'View Results',
        days: 'days',
        remaining: 'remaining',
        notStarted: 'Not started',
        inProgress: 'In progress',
        closed: 'Closed',
        fieldRequired: 'This field is required',
        error: 'Error',
        checkAllQuestionsBeforeProceed: 'Please check you have answered all the questions before trying to proceed.',
        whatsAppIntro: "Hi Mike, thanks for agreeing to take part in our research activity, {projectName} for {accountName}. Please simply reply 'Y' to this message to get started and we’ll reply with further details."
    },
    in: {
        enterYourTextHere: 'Masukkan teks Anda di sini',
        loading: "Memuat",
        loadingPage: "Memuat halaman...",
        previous: "Sebelumnya",
        next: "Berikutnya",
        fetchingSurvey: "Mengambil survei...",
        completingSurvey: "Menyelesaikan survei...",
        registerNow: "Daftar Sekarang",
        startSurvey: "Mulai Survei",
        redirectMessage: "Anda akan secara otomatis dialihkan kembali ke dasbor Anda dalam {countDown} detik...",
        edit: 'Sunting',
        delete: 'Hapus',
        likeThisPost: 'Suka postingan ini',
        upVoteThisPost: 'Upvote postingan ini',
        saveAndClose: 'Simpan dan tutup',
        close: 'Tutup',
        cancel: 'Batal',
        editingMessage: 'Menyunting pesan',
        showMore: 'Tampilkan lebih banyak',
        showLess: 'Tampilkan lebih sedikit',
        option: 'Opsi',
        percentage: 'Persentase',
        count: 'Jumlah',
        label: 'Label',
        pleaseSelectAnswer: 'Silakan pilih jawaban',
        pleaseSpecify: 'Silakan tentukan',
        enterEmail: 'Masukkan alamat email di sini',
        enterNumber: 'Masukkan nomor di sini',
        enterPhone: 'Masukkan nomor telepon di sini',
        mediaAppearsHere: 'Media akan muncul di sini setelah diunggah',
        takePart: 'Ikut serta',
        continue: 'Lanjutkan',
        view: 'Lihat',
        sendWhatsAppInvite: 'Kirim Undangan WhatsApp',
        currentlyUnavailable: 'Saat ini tidak tersedia',
        seeWhatsApp: 'Lihat WhatsApp',
        viewFinalResults: 'Lihat Hasil Akhir',
        draft: 'Draf',
        upNext: 'Berikutnya',
        completed: 'Selesai',
        forum: 'Forum',
        pinnedToDashboard: 'Forum ini disematkan di dashboard peserta',
        newLabel: 'Baru',
        aiAnalysisEnabled: 'Analisis AI diaktifkan',
        partOfSequence: 'Bagian dari urutan',
        dateClosed: 'Tanggal Ditutup:',
        participants: 'Peserta',
        noMobileNumber: 'Tidak ada nomor ponsel, harap tambahkan di pengaturan',
        viewResults: 'Lihat Hasil',
        days: 'hari',
        remaining: 'tersisa',
        notStarted: 'Belum dimulai',
        inProgress: 'Sedang berlangsung',
        closed: 'Ditutup',
        fieldRequired: 'Kolom ini wajib diisi',
        error: 'Kesalahan',
        checkAllQuestionsBeforeProceed: 'Harap pastikan Anda telah menjawab semua pertanyaan sebelum mencoba melanjutkan.',
        whatsAppIntro: "Hai Mike, terima kasih telah setuju untuk ikut serta dalam kegiatan riset kami, {projectName} for {accountName}. Silakan balas dengan 'Y' untuk memulai dan kami akan mengirimkan rincian lebih lanjut."
    },
    zh: {
        enterYourTextHere: '在此输入您的文本',
        loading: "加载中",
        loadingPage: "页面加载中...",
        previous: "上一步",
        next: "下一步",
        fetchingSurvey: "正在获取调查...",
        completingSurvey: "正在完成调查...",
        registerNow: "立即注册",
        startSurvey: "开始调查",
        redirectMessage: "您将在 {countDown} 秒后自动返回到您的仪表盘...",
        edit: '编辑',
        delete: '删除',
        likeThisPost: '喜欢这篇帖子',
        upVoteThisPost: '为此帖投赞成票',
        saveAndClose: '保存并关闭',
        close: '关闭',
        cancel: '取消',
        editingMessage: '编辑消息',
        showMore: '显示更多',
        showLess: '显示更少',
        option: '选项',
        percentage: '百分比',
        count: '计数',
        label: '标签',
        pleaseSelectAnswer: '请选择答案',
        pleaseSpecify: '请说明',
        enterEmail: '在此输入电子邮件地址',
        enterNumber: '在此输入数字',
        enterPhone: '在此输入电话号码',
        mediaAppearsHere: '媒体上传后将在此显示',
        takePart: '参与',
        continue: '继续',
        view: '查看',
        sendWhatsAppInvite: '发送 WhatsApp 邀请',
        currentlyUnavailable: '当前不可用',
        seeWhatsApp: '查看 WhatsApp',
        viewFinalResults: '查看最终结果',
        draft: '草稿',
        upNext: '接下来',
        completed: '已完成',
        forum: '论坛',
        pinnedToDashboard: '此论坛已固定在参与者仪表盘上',
        newLabel: '新',
        aiAnalysisEnabled: '启用 AI 分析',
        partOfSequence: '属于一个序列',
        dateClosed: '关闭日期:',
        participants: '参与者',
        noMobileNumber: '未找到手机号码，请在设置中添加',
        viewResults: '查看结果',
        days: '天',
        remaining: '剩余',
        notStarted: '未开始',
        inProgress: '进行中',
        closed: '已关闭',
        fieldRequired: '此字段为必填',
        error: '错误',
        checkAllQuestionsBeforeProceed: '请确保您已回答所有问题后再继续。',
        whatsAppIntro: "嗨 Mike，感谢您同意参与我们的研究活动, {projectName} for {accountName}。请回复 'Y' 开始，我们将发送更多详情。"
    },
    nl: {
        enterYourTextHere: 'Voer hier je tekst in',
        loading: "Laden",
        loadingPage: "Pagina wordt geladen...",
        previous: "Vorige",
        next: "Volgende",
        fetchingSurvey: "Enquête ophalen...",
        completingSurvey: "Enquête afronden...",
        registerNow: "Meld je nu aan",
        startSurvey: "Start enquête",
        redirectMessage: "Je wordt automatisch teruggeleid naar je dashboard in {countDown} seconden...",
        edit: 'Bewerken',
        delete: 'Verwijderen',
        likeThisPost: 'Vind dit bericht leuk',
        upVoteThisPost: 'Stem op dit bericht',
        saveAndClose: 'Opslaan en sluiten',
        close: 'Sluiten',
        cancel: 'Annuleren',
        editingMessage: 'Bericht bewerken',
        showMore: 'Toon meer',
        showLess: 'Toon minder',
        option: 'Optie',
        percentage: 'Percentage',
        count: 'Aantal',
        label: 'Label',
        pleaseSelectAnswer: 'Selecteer een antwoord',
        pleaseSpecify: 'Specificeer',
        enterEmail: 'Voer hier je e-mailadres in',
        enterNumber: 'Voer hier een nummer in',
        enterPhone: 'Voer hier je telefoonnummer in',
        mediaAppearsHere: 'Media wordt hier weergegeven zodra deze is geüpload',
        takePart: 'Doe mee',
        continue: 'Ga verder',
        view: 'Bekijk',
        sendWhatsAppInvite: 'Stuur WhatsApp-uitnodiging',
        currentlyUnavailable: 'Momenteel niet beschikbaar',
        seeWhatsApp: 'Bekijk WhatsApp',
        viewFinalResults: 'Bekijk definitieve resultaten',
        draft: 'Concept',
        upNext: 'Als volgende',
        completed: 'Voltooid',
        forum: 'Forum',
        pinnedToDashboard: 'Dit forum is vastgezet op het dashboard van de deelnemers',
        newLabel: 'Nieuw',
        aiAnalysisEnabled: 'AI-analyse ingeschakeld',
        partOfSequence: 'Onderdeel van een reeks',
        dateClosed: 'Datum gesloten:',
        participants: 'Deelnemers',
        noMobileNumber: 'Geen mobiel nummer gevonden, voeg er een toe in de instellingen',
        viewResults: 'Bekijk resultaten',
        days: 'dagen',
        remaining: 'resterend',
        notStarted: 'Niet gestart',
        inProgress: 'Bezig',
        closed: 'Gesloten',
        fieldRequired: 'Dit veld is verplicht',
        error: 'Fout',
        checkAllQuestionsBeforeProceed: 'Controleer of u alle vragen hebt beantwoord voordat u verder gaat.',
        whatsAppIntro: "Hoi Mike, bedankt dat je hebt ingestemd om deel te nemen aan onze onderzoeksactiviteit, {projectName} for {accountName}. Reageer simpelweg met 'Y' op dit bericht om te beginnen en wij sturen je verdere details."
    },
    fi: {
        enterYourTextHere: 'Syötä tekstisi tähän',
        loading: "Ladataan",
        loadingPage: "Ladataan sivua...",
        previous: "Edellinen",
        next: "Seuraava",
        fetchingSurvey: "Haetaan kyselyä...",
        completingSurvey: "Täydennetään kyselyä...",
        registerNow: "Rekisteröidy nyt",
        startSurvey: "Aloita kysely",
        redirectMessage: "Sinut ohjataan automaattisesti takaisin kojelautaan {countDown} sekunnin kuluttua...",
        edit: 'Muokkaa',
        delete: 'Poista',
        likeThisPost: 'Tykkää tästä viestistä',
        upVoteThisPost: 'Äänestä tätä viestiä ylös',
        saveAndClose: 'Tallenna ja sulje',
        close: 'Sulje',
        cancel: 'Peruuta',
        editingMessage: 'Muokataan viestiä',
        showMore: 'Näytä lisää',
        showLess: 'Näytä vähemmän',
        option: 'Vaihtoehto',
        percentage: 'Prosentti',
        count: 'Lukumäärä',
        label: 'Tunniste',
        pleaseSelectAnswer: 'Valitse vastaus',
        pleaseSpecify: 'Tarkenna',
        enterEmail: 'Syötä sähköpostiosoite tähän',
        enterNumber: 'Syötä numero tähän',
        enterPhone: 'Syötä puhelinnumero tähän',
        mediaAppearsHere: 'Media näkyy täällä, kun se on ladattu',
        takePart: 'Osallistu',
        continue: 'Jatka',
        view: 'Näytä',
        sendWhatsAppInvite: 'Lähetä WhatsApp-kutsu',
        currentlyUnavailable: 'Ei tällä hetkellä saatavilla',
        seeWhatsApp: 'Näytä WhatsApp',
        viewFinalResults: 'Näytä lopulliset tulokset',
        draft: 'Luonnos',
        upNext: 'Seuraavaksi',
        completed: 'Valmis',
        forum: 'Foorumi',
        pinnedToDashboard: 'Tämä foorumi on kiinnitetty osallistujien hallintapaneeliin',
        newLabel: 'Uusi',
        aiAnalysisEnabled: 'AI-analyysi käytössä',
        partOfSequence: 'Osa jäsentä',
        dateClosed: 'Suljettu päivämäärä:',
        participants: 'Osallistujat',
        noMobileNumber: 'Matkapuhelinnumeroa ei löytynyt, lisää se asetuksista',
        viewResults: 'Näytä tulokset',
        days: 'päivää',
        remaining: 'jäljellä',
        notStarted: 'Ei aloitettu',
        inProgress: 'Käynnissä',
        closed: 'Suljettu',
        fieldRequired: 'Tämä kenttä on pakollinen',
        error: 'Virhe',
        checkAllQuestionsBeforeProceed: 'Tarkista, että olet vastannut kaikkiin kysymyksiin ennen jatkamista.',
        whatsAppIntro: "Hei Mike, kiitos että suostuit osallistumaan tutkimustoimintaamme, {projectName} for {accountName}. Vastaa viestiin kirjoittamalla 'Y' aloittaaksesi, niin lähetämme lisätietoja."
    },
    fr: {
        enterYourTextHere: 'Entrez votre texte ici',
        loading: "Chargement",
        loadingPage: "Chargement de la page...",
        previous: "Précédent",
        next: "Suivant",
        fetchingSurvey: "Récupération du sondage...",
        completingSurvey: "Finalisation du sondage...",
        registerNow: "Inscrivez-vous maintenant",
        startSurvey: "Commencer le sondage",
        redirectMessage: "Vous serez automatiquement redirigé vers votre tableau de bord dans {countDown} secondes...",
        edit: 'Modifier',
        delete: 'Supprimer',
        likeThisPost: 'Aimez ce post',
        upVoteThisPost: 'Votez pour ce post',
        saveAndClose: 'Enregistrer et fermer',
        close: 'Fermer',
        cancel: 'Annuler',
        editingMessage: 'Modification du message',
        showMore: 'Afficher plus',
        showLess: 'Afficher moins',
        option: 'Option',
        percentage: 'Pourcentage',
        count: 'Nombre',
        label: 'Étiquette',
        pleaseSelectAnswer: 'Veuillez sélectionner une réponse',
        pleaseSpecify: 'Veuillez préciser',
        enterEmail: 'Entrez votre adresse e-mail ici',
        enterNumber: 'Entrez un numéro ici',
        enterPhone: 'Entrez un numéro de téléphone ici',
        mediaAppearsHere: 'Les médias apparaîtront ici une fois téléchargés',
        takePart: 'Participer',
        continue: 'Continuer',
        view: 'Voir',
        sendWhatsAppInvite: 'Envoyer une invitation WhatsApp',
        currentlyUnavailable: 'Actuellement indisponible',
        seeWhatsApp: 'Voir WhatsApp',
        viewFinalResults: 'Voir les résultats finaux',
        draft: 'Brouillon',
        upNext: 'À venir',
        completed: 'Terminé',
        forum: 'Forum',
        pinnedToDashboard: 'Ce forum est épinglé sur le tableau de bord des participants',
        newLabel: 'Nouveau',
        aiAnalysisEnabled: 'Analyse IA activée',
        partOfSequence: "Fais partie d'une séquence",
        dateClosed: 'Date de clôture:',
        participants: 'Participants',
        noMobileNumber: 'Aucun numéro mobile trouvé, veuillez en ajouter un dans les paramètres',
        viewResults: 'Voir les résultats',
        days: 'jours',
        remaining: 'restants',
        notStarted: 'Non démarré',
        inProgress: 'En cours',
        closed: 'Fermé',
        fieldRequired: 'Ce champ est obligatoire',
        error: 'Erreur',
        checkAllQuestionsBeforeProceed: 'Veuillez vérifier que vous avez répondu à toutes les questions avant de continuer.',
        whatsAppIntro: "Salut Mike, merci d'avoir accepté de participer à notre activité de recherche, {projectName} for {accountName}. Veuillez répondre simplement 'Y' à ce message pour commencer et nous vous enverrons plus de détails."
    },
    de: {
        enterYourTextHere: 'Geben Sie hier Ihren Text ein',
        loading: "Wird geladen",
        loadingPage: "Seite wird geladen...",
        previous: "Zurück",
        next: "Weiter",
        fetchingSurvey: "Umfrage wird geladen...",
        completingSurvey: "Umfrage abschließen...",
        registerNow: "Jetzt registrieren",
        startSurvey: "Umfrage starten",
        redirectMessage: "Sie werden in {countDown} Sekunden automatisch zu Ihrem Dashboard zurückgeleitet...",
        edit: 'Bearbeiten',
        delete: 'Löschen',
        likeThisPost: 'Gefällt mir dieser Beitrag',
        upVoteThisPost: 'Upvote diesen Beitrag',
        saveAndClose: 'Speichern und schließen',
        close: 'Schließen',
        cancel: 'Abbrechen',
        editingMessage: 'Nachricht bearbeiten',
        showMore: 'Mehr anzeigen',
        showLess: 'Weniger anzeigen',
        option: 'Option',
        percentage: 'Prozentsatz',
        count: 'Anzahl',
        label: 'Beschriftung',
        pleaseSelectAnswer: 'Bitte wählen Sie eine Antwort aus',
        pleaseSpecify: 'Bitte angeben',
        enterEmail: 'Geben Sie hier Ihre E-Mail-Adresse ein',
        enterNumber: 'Geben Sie hier eine Zahl ein',
        enterPhone: 'Geben Sie hier Ihre Telefonnummer ein',
        mediaAppearsHere: 'Medien werden hier angezeigt, sobald sie hochgeladen wurden',
        takePart: 'Teilnehmen',
        continue: 'Fortfahren',
        view: 'Ansehen',
        sendWhatsAppInvite: 'WhatsApp-Einladung senden',
        currentlyUnavailable: 'Derzeit nicht verfügbar',
        seeWhatsApp: 'WhatsApp anzeigen',
        viewFinalResults: 'Endgültige Ergebnisse ansehen',
        draft: 'Entwurf',
        upNext: 'Als Nächstes',
        completed: 'Abgeschlossen',
        forum: 'Forum',
        pinnedToDashboard: 'Dieses Forum ist auf dem Dashboard der Teilnehmer angeheftet',
        newLabel: 'Neu',
        aiAnalysisEnabled: 'KI-Analyse aktiviert',
        partOfSequence: 'Teil einer Sequenz',
        dateClosed: 'Abschlussdatum:',
        participants: 'Teilnehmer',
        noMobileNumber: 'Keine Handynummer gefunden, bitte in den Einstellungen hinzufügen',
        viewResults: 'Ergebnisse ansehen',
        days: 'Tage',
        remaining: 'verbleibend',
        notStarted: 'Nicht gestartet',
        inProgress: 'In Bearbeitung',
        closed: 'Geschlossen',
        fieldRequired: 'Dieses Feld ist erforderlich',
        error: 'Fehler',
        checkAllQuestionsBeforeProceed: 'Bitte überprüfen Sie, ob Sie alle Fragen beantwortet haben, bevor Sie fortfahren.',
        whatsAppIntro: "Hallo Mike, vielen Dank, dass du zugestimmt hast, an unserer Forschungsaktivität teilzunehmen, {projectName} for {accountName}. Bitte antworte einfach mit 'Y' auf diese Nachricht, um zu starten, und wir werden dir weitere Details zukommen lassen."
    },
    hi: {
        enterYourTextHere: 'यहां अपना पाठ दर्ज करें',
        loading: "लोड हो रहा है",
        loadingPage: "पृष्ठ लोड हो रहा है...",
        previous: "पिछला",
        next: "अगला",
        fetchingSurvey: "सर्वेक्षण लाया जा रहा है...",
        completingSurvey: "सर्वेक्षण पूरा किया जा रहा है...",
        registerNow: "अब पंजीकरण करें",
        startSurvey: "सर्वेक्षण शुरू करें",
        redirectMessage: "आपको {countDown} सेकंड में अपने डैशबोर्ड पर वापस ले जाया जाएगा...",
        edit: 'संपादित करें',
        delete: 'हटाएं',
        likeThisPost: 'इस पोस्ट को लाइक करें',
        upVoteThisPost: 'इस पोस्ट को अपवोट करें',
        saveAndClose: 'सहेजें और बंद करें',
        close: 'बंद करें',
        cancel: 'रद्द करें',
        editingMessage: 'संदेश संपादित करना',
        showMore: 'और दिखाएं',
        showLess: 'कम दिखाएं',
        option: 'विकल्प',
        percentage: 'प्रतिशत',
        count: 'गिनती',
        label: 'लेबल',
        pleaseSelectAnswer: 'कृपया एक उत्तर चुनें',
        pleaseSpecify: 'कृपया निर्दिष्ट करें',
        enterEmail: 'यहां ईमेल पता दर्ज करें',
        enterNumber: 'यहां संख्या दर्ज करें',
        enterPhone: 'यहां फोन नंबर दर्ज करें',
        mediaAppearsHere: 'मीडिया अपलोड होने के बाद यहाँ दिखाई देगा',
        takePart: 'भाग लें',
        continue: 'जारी रखें',
        view: 'देखें',
        sendWhatsAppInvite: 'व्हाट्सएप निमंत्रण भेजें',
        currentlyUnavailable: 'वर्तमान में उपलब्ध नहीं',
        seeWhatsApp: 'व्हाट्सएप देखें',
        viewFinalResults: 'अंतिम परिणाम देखें',
        draft: 'ड्राफ्ट',
        upNext: 'आगे आने वाला',
        completed: 'पूरा हुआ',
        forum: 'फोरम',
        pinnedToDashboard: 'यह फोरम प्रतिभागी डैशबोर्ड पर पिन किया गया है',
        newLabel: 'नया',
        aiAnalysisEnabled: 'एआई विश्लेषण सक्षम है',
        partOfSequence: 'एक श्रृंखला का हिस्सा',
        dateClosed: 'बंद तिथि:',
        participants: 'प्रतिभागी',
        noMobileNumber: 'कोई मोबाइल नंबर नहीं मिला, कृपया सेटिंग्स में जोड़ें',
        viewResults: 'परिणाम देखें',
        days: 'दिन',
        remaining: 'बचे हुए',
        notStarted: 'शुरू नहीं हुआ',
        inProgress: 'चल रहा है',
        closed: 'बंद',
        fieldRequired: 'यह फ़ील्ड आवश्यक है',
        error: 'त्रुटि',
        checkAllQuestionsBeforeProceed: 'कृपया आगे बढ़ने से पहले सुनिश्चित करें कि आपने सभी प्रश्नों के उत्तर दिए हैं।',
        whatsAppIntro: "हाय Mike, हमारे अनुसंधान गतिविधि में भाग लेने के लिए सहमति देने के लिए धन्यवाद, {projectName} for {accountName}. कृपया 'Y' लिखकर उत्तर दें ताकि आप शुरू कर सकें, और हम आपको आगे की जानकारी भेजेंगे।"
    },
    it: {
        enterYourTextHere: 'Inserisci il tuo testo qui',
        loading: "Caricamento",
        loadingPage: "Caricamento della pagina...",
        previous: "Precedente",
        next: "Successivo",
        fetchingSurvey: "Recupero sondaggio...",
        completingSurvey: "Completamento sondaggio...",
        registerNow: "Registrati ora",
        startSurvey: "Inizia sondaggio",
        redirectMessage: "Verrai reindirizzato automaticamente al tuo cruscotto in {countDown} secondi...",
        edit: 'Modifica',
        delete: 'Elimina',
        likeThisPost: 'Metti mi piace a questo post',
        upVoteThisPost: 'Dai un voto positivo a questo post',
        saveAndClose: 'Salva e chiudi',
        close: 'Chiudi',
        cancel: 'Annulla',
        editingMessage: 'Modifica messaggio',
        showMore: 'Mostra di più',
        showLess: 'Mostra di meno',
        option: 'Opzione',
        percentage: 'Percentuale',
        count: 'Conteggio',
        label: 'Etichetta',
        pleaseSelectAnswer: 'Seleziona una risposta',
        pleaseSpecify: 'Si prega di specificare',
        enterEmail: "Inserisci qui l'indirizzo email",
        enterNumber: 'Inserisci qui il numero',
        enterPhone: 'Inserisci qui il numero di telefono',
        mediaAppearsHere: 'I media appariranno qui una volta caricati',
        takePart: 'Partecipa',
        continue: 'Continua',
        view: 'Visualizza',
        sendWhatsAppInvite: 'Invia invito WhatsApp',
        currentlyUnavailable: 'Attualmente non disponibile',
        seeWhatsApp: 'Visualizza WhatsApp',
        viewFinalResults: 'Visualizza risultati finali',
        draft: 'Bozza',
        upNext: 'Prossimamente',
        completed: 'Completato',
        forum: 'Forum',
        pinnedToDashboard: 'Questo forum è fissato sul cruscotto dei partecipanti',
        newLabel: 'Nuovo',
        aiAnalysisEnabled: 'Analisi AI abilitata',
        partOfSequence: 'Parte di una sequenza',
        dateClosed: 'Data di chiusura:',
        participants: 'Partecipanti',
        noMobileNumber: 'Nessun numero di cellulare trovato, aggiungine uno nelle impostazioni',
        viewResults: 'Visualizza risultati',
        days: 'giorni',
        remaining: 'rimanenti',
        notStarted: 'Non iniziato',
        inProgress: 'In corso',
        closed: 'Chiuso',
        fieldRequired: 'Questo campo è obbligatorio',
        error: 'Errore',
        checkAllQuestionsBeforeProceed: 'Controlla di aver risposto a tutte le domande prima di procedere.',
        whatsAppIntro: "Ciao Mike, grazie per aver accettato di partecipare alla nostra attività di ricerca, {projectName} for {accountName}. Rispondi semplicemente con 'Y' a questo messaggio per iniziare e ti invieremo ulteriori dettagli."
    },
    ja: {
        enterYourTextHere: 'ここにテキストを入力してください',
        loading: "読み込み中",
        loadingPage: "ページを読み込み中...",
        previous: "前へ",
        next: "次へ",
        fetchingSurvey: "アンケートを取得中...",
        completingSurvey: "アンケートを完了中...",
        registerNow: "今すぐ登録",
        startSurvey: "アンケートを開始",
        redirectMessage: "{countDown}秒後に自動的にダッシュボードに戻ります...",
        edit: '編集',
        delete: '削除',
        likeThisPost: 'この投稿にいいね！',
        upVoteThisPost: 'この投稿にアップボートする',
        saveAndClose: '保存して閉じる',
        close: '閉じる',
        cancel: 'キャンセル',
        editingMessage: 'メッセージを編集中',
        showMore: 'もっと見る',
        showLess: '少なく表示',
        option: 'オプション',
        percentage: 'パーセンテージ',
        count: 'カウント',
        label: 'ラベル',
        pleaseSelectAnswer: '回答を選択してください',
        pleaseSpecify: '具体的に記入してください',
        enterEmail: 'ここにメールアドレスを入力してください',
        enterNumber: 'ここに数字を入力してください',
        enterPhone: 'ここに電話番号を入力してください',
        mediaAppearsHere: 'メディアはアップロード後にここに表示されます',
        takePart: '参加する',
        continue: '続ける',
        view: '見る',
        sendWhatsAppInvite: 'WhatsApp招待を送信',
        currentlyUnavailable: '現在利用できません',
        seeWhatsApp: 'WhatsAppを見る',
        viewFinalResults: '最終結果を見る',
        draft: '下書き',
        upNext: '次へ',
        completed: '完了',
        forum: 'フォーラム',
        pinnedToDashboard: 'このフォーラムは参加者のダッシュボードに固定されています',
        newLabel: '新着',
        aiAnalysisEnabled: 'AI分析が有効です',
        partOfSequence: 'シーケンスの一部',
        dateClosed: '終了日:',
        participants: '参加者',
        noMobileNumber: '携帯番号が見つかりません。設定で追加してください',
        viewResults: '結果を見る',
        days: '日',
        remaining: '残り',
        notStarted: '未開始',
        inProgress: '進行中',
        closed: '終了',
        fieldRequired: 'このフィールドは必須です',
        error: 'エラー',
        checkAllQuestionsBeforeProceed: '続行する前に、すべての質問に回答しているか確認してください。',
        whatsAppIntro: "こんにちは Mike、当社の調査活動にご参加いただけることに感謝します、{projectName} for {accountName}。このメッセージに「Y」と返信して開始してください。詳細は追ってご連絡いたします。"
    },
    ko: {
        enterYourTextHere: '여기에 텍스트를 입력하세요',
        loading: "로딩 중",
        loadingPage: "페이지 로딩 중...",
        previous: "이전",
        next: "다음",
        fetchingSurvey: "설문조사 가져오는 중...",
        completingSurvey: "설문조사 완료 중...",
        registerNow: "지금 등록하세요",
        startSurvey: "설문 시작",
        redirectMessage: "{countDown}초 후에 자동으로 대시보드로 돌아갑니다...",
        edit: '편집',
        delete: '삭제',
        likeThisPost: '이 게시물을 좋아요',
        upVoteThisPost: '이 게시물에 업보트하기',
        saveAndClose: '저장하고 닫기',
        close: '닫기',
        cancel: '취소',
        editingMessage: '메시지 편집 중',
        showMore: '더 보기',
        showLess: '덜 보기',
        option: '옵션',
        percentage: '백분율',
        count: '카운트',
        label: '레이블',
        pleaseSelectAnswer: '답변을 선택해 주세요',
        pleaseSpecify: '구체적으로 입력해 주세요',
        enterEmail: '여기에 이메일 주소를 입력하세요',
        enterNumber: '여기에 숫자를 입력하세요',
        enterPhone: '여기에 전화번호를 입력하세요',
        mediaAppearsHere: '업로드되면 미디어가 여기에 표시됩니다',
        takePart: '참여하기',
        continue: '계속하기',
        view: '보기',
        sendWhatsAppInvite: 'WhatsApp 초대 보내기',
        currentlyUnavailable: '현재 이용할 수 없음',
        seeWhatsApp: 'WhatsApp 보기',
        viewFinalResults: '최종 결과 보기',
        draft: '초안',
        upNext: '다음 예정',
        completed: '완료됨',
        forum: '포럼',
        pinnedToDashboard: '이 포럼은 참가자 대시보드에 고정되어 있습니다',
        newLabel: '새로운',
        aiAnalysisEnabled: 'AI 분석 사용 중',
        partOfSequence: '시퀀스의 일부',
        dateClosed: '종료 날짜:',
        participants: '참가자',
        noMobileNumber: '휴대폰 번호를 찾을 수 없습니다. 설정에서 추가하세요',
        viewResults: '결과 보기',
        days: '일',
        remaining: '남음',
        notStarted: '시작 전',
        inProgress: '진행 중',
        closed: '종료됨',
        fieldRequired: '이 필드는 필수입니다',
        error: '오류',
        checkAllQuestionsBeforeProceed: '계속하기 전에 모든 질문에 답변했는지 확인해 주세요.',
        whatsAppIntro: "안녕 Mike, 저희 연구 활동에 참여해 주셔서 감사합니다, {projectName} for {accountName}. 시작하려면 이 메시지에 'Y'라고 답장해 주세요. 추가 세부 사항은 추후 안내해 드리겠습니다."
    },
    vi: {
        enterYourTextHere: 'Nhập văn bản của bạn ở đây',
        loading: "Đang tải",
        loadingPage: "Đang tải trang...",
        previous: "Trước",
        next: "Tiếp theo",
        fetchingSurvey: "Đang lấy khảo sát...",
        completingSurvey: "Đang hoàn thành khảo sát...",
        registerNow: "Đăng ký ngay bây giờ",
        startSurvey: "Bắt đầu khảo sát",
        redirectMessage: "Bạn sẽ tự động được chuyển hướng trở lại bảng điều khiển của mình trong {countDown} giây...",
        edit: 'Chỉnh sửa',
        delete: 'Xóa',
        likeThisPost: 'Thích bài đăng này',
        upVoteThisPost: 'Bỏ phiếu ủng hộ bài đăng này',
        saveAndClose: 'Lưu và đóng',
        close: 'Đóng',
        cancel: 'Hủy bỏ',
        editingMessage: 'Đang chỉnh sửa tin nhắn',
        showMore: 'Hiển thị thêm',
        showLess: 'Hiển thị ít hơn',
        option: 'Tùy chọn',
        percentage: 'Phần trăm',
        count: 'Số lượng',
        label: 'Nhãn',
        pleaseSelectAnswer: 'Vui lòng chọn một câu trả lời',
        pleaseSpecify: 'Vui lòng ghi rõ',
        enterEmail: 'Nhập địa chỉ email của bạn ở đây',
        enterNumber: 'Nhập số ở đây',
        enterPhone: 'Nhập số điện thoại của bạn ở đây',
        mediaAppearsHere: 'Phương tiện sẽ hiển thị ở đây sau khi được tải lên',
        takePart: 'Tham gia',
        continue: 'Tiếp tục',
        view: 'Xem',
        sendWhatsAppInvite: 'Gửi lời mời WhatsApp',
        currentlyUnavailable: 'Hiện không khả dụng',
        seeWhatsApp: 'Xem WhatsApp',
        viewFinalResults: 'Xem kết quả cuối cùng',
        draft: 'Bản nháp',
        upNext: 'Sắp tới',
        completed: 'Hoàn thành',
        forum: 'Diễn đàn',
        pinnedToDashboard: 'Diễn đàn này đã được ghim trên bảng điều khiển của người tham gia',
        newLabel: 'Mới',
        aiAnalysisEnabled: 'Phân tích AI đã được kích hoạt',
        partOfSequence: 'Là một phần của chuỗi',
        dateClosed: 'Ngày đóng:',
        participants: 'Người tham gia',
        noMobileNumber: 'Không tìm thấy số điện thoại di động, vui lòng thêm trong cài đặt',
        viewResults: 'Xem kết quả',
        days: 'ngày',
        remaining: 'còn lại',
        notStarted: 'Chưa bắt đầu',
        inProgress: 'Đang tiến hành',
        closed: 'Đã đóng',
        fieldRequired: 'Trường này là bắt buộc',
        error: 'Lỗi',
        checkAllQuestionsBeforeProceed: 'Vui lòng kiểm tra bạn đã trả lời tất cả các câu hỏi trước khi tiếp tục.',
        whatsAppIntro: "Chào Mike, cảm ơn bạn đã đồng ý tham gia hoạt động nghiên cứu của chúng tôi, {projectName} for {accountName}. Vui lòng trả lời 'Y' cho tin nhắn này để bắt đầu và chúng tôi sẽ gửi thêm chi tiết."
    },
    pl: {
        enterYourTextHere: 'Wprowadź swój tekst tutaj',
        loading: 'Wczytywanie',
        loadingPage: 'Wczytywanie strony...',
        previous: 'Poprzedni',
        next: 'Następny',
        fetchingSurvey: 'Pobieranie ankiety...',
        completingSurvey: 'Kończenie ankiety...',
        registerNow: 'Zarejestruj się teraz',
        startSurvey: 'Rozpocznij ankietę',
        redirectMessage: 'Zostaniesz automatycznie przekierowany z powrotem do pulpitu w ciągu {countDown} sekund...',
        edit: 'Edytuj',
        delete: 'Usuń',
        likeThisPost: 'Polub ten post',
        upVoteThisPost: 'Oddaj głos za tym postem',
        saveAndClose: 'Zapisz i zamknij',
        close: 'Zamknij',
        cancel: 'Anuluj',
        editingMessage: 'Edytowanie wiadomości',
        showMore: 'Pokaż więcej',
        showLess: 'Pokaż mniej',
        option: 'Opcja',
        percentage: 'Procent',
        count: 'Liczba',
        label: 'Etykieta',
        pleaseSelectAnswer: 'Proszę wybrać odpowiedź',
        pleaseSpecify: 'Proszę sprecyzować',
        enterEmail: 'Wprowadź adres e-mail tutaj',
        enterNumber: 'Wprowadź numer tutaj',
        enterPhone: 'Wprowadź numer telefonu tutaj',
        mediaAppearsHere: 'Media pojawi się tutaj po przesłaniu',
        takePart: 'Weź udział',
        continue: 'Kontynuuj',
        view: 'Zobacz',
        sendWhatsAppInvite: 'Wyślij zaproszenie WhatsApp',
        currentlyUnavailable: 'Obecnie niedostępne',
        seeWhatsApp: 'Zobacz WhatsApp',
        viewFinalResults: 'Zobacz ostateczne wyniki',
        draft: 'Szkic',
        upNext: 'Następnie',
        completed: 'Zakończono',
        forum: 'Forum',
        pinnedToDashboard: 'To forum jest przypięte do pulpitu uczestnika',
        newLabel: 'Nowy',
        aiAnalysisEnabled: 'Analiza AI włączona',
        partOfSequence: 'Część sekwencji',
        dateClosed: 'Data zamknięcia:',
        participants: 'Uczestnicy',
        noMobileNumber: 'Nie znaleziono numeru telefonu, dodaj go w ustawieniach',
        viewResults: 'Zobacz wyniki',
        days: 'dni',
        remaining: 'pozostało',
        notStarted: 'Nie rozpoczęto',
        inProgress: 'W trakcie',
        closed: 'Zamknięte',
        fieldRequired: 'To pole jest wymagane',
        error: 'Błąd',
        checkAllQuestionsBeforeProceed: 'Sprawdź, czy odpowiedziałeś na wszystkie pytania, zanim spróbujesz kontynuować.',
        whatsAppIntro: "Cześć Mike, dziękujemy za zgodę na udział w naszej aktywności badawczej, {projectName} dla {accountName}. Proszę odpowiedzieć 'Y' na tę wiadomość, aby rozpocząć, a wyślemy więcej szczegółów."
    },
    pt: {
        enterYourTextHere: 'Digite seu texto aqui',
        loading: 'Carregando',
        loadingPage: 'Carregando página...',
        previous: 'Anterior',
        next: 'Próximo',
        fetchingSurvey: 'Obtendo pesquisa...',
        completingSurvey: 'Concluindo pesquisa...',
        registerNow: 'Registre-se agora',
        startSurvey: 'Iniciar pesquisa',
        redirectMessage: 'Você será redirecionado automaticamente de volta ao seu painel em {countDown} segundos...',
        edit: 'Editar',
        delete: 'Excluir',
        likeThisPost: 'Curtir esta postagem',
        upVoteThisPost: 'Votar positivamente nesta postagem',
        saveAndClose: 'Salvar e fechar',
        close: 'Fechar',
        cancel: 'Cancelar',
        editingMessage: 'Editando mensagem',
        showMore: 'Mostrar mais',
        showLess: 'Mostrar menos',
        option: 'Opção',
        percentage: 'Percentual',
        count: 'Contagem',
        label: 'Rótulo',
        pleaseSelectAnswer: 'Por favor selecione uma resposta',
        pleaseSpecify: 'Por favor especifique',
        enterEmail: 'Digite seu e-mail aqui',
        enterNumber: 'Digite um número aqui',
        enterPhone: 'Digite um número de telefone aqui',
        mediaAppearsHere: 'Mídia aparecerá aqui após o upload',
        takePart: 'Participar',
        continue: 'Continuar',
        view: 'Visualizar',
        sendWhatsAppInvite: 'Enviar convite via WhatsApp',
        currentlyUnavailable: 'Atualmente indisponível',
        seeWhatsApp: 'Ver WhatsApp',
        viewFinalResults: 'Ver resultados finais',
        draft: 'Rascunho',
        upNext: 'Em seguida',
        completed: 'Concluído',
        forum: 'Fórum',
        pinnedToDashboard: 'Este fórum está fixado no painel de participantes',
        newLabel: 'Novo',
        aiAnalysisEnabled: 'Análise de IA ativada',
        partOfSequence: 'Parte de uma sequência',
        dateClosed: 'Data de encerramento:',
        participants: 'Participantes',
        noMobileNumber: 'Nenhum número de celular encontrado, por favor adicione um nas configurações',
        viewResults: 'Ver resultados',
        days: 'dias',
        remaining: 'restantes',
        notStarted: 'Não iniciado',
        inProgress: 'Em andamento',
        closed: 'Fechado',
        fieldRequired: 'Este campo é obrigatório',
        error: 'Erro',
        checkAllQuestionsBeforeProceed: 'Verifique se respondeu a todas as perguntas antes de tentar continuar.',
        whatsAppIntro: "Oi Mike, obrigado por concordar em participar da nossa atividade de pesquisa, {projectName} para {accountName}. Por favor, responda 'Y' a esta mensagem para começar e enviaremos mais detalhes."
    },
    es: {
        enterYourTextHere: 'Introduce tu texto aquí',
        loading: 'Cargando',
        loadingPage: 'Cargando página...',
        previous: 'Anterior',
        next: 'Siguiente',
        fetchingSurvey: 'Recuperando encuesta...',
        completingSurvey: 'Completando encuesta...',
        registerNow: 'Regístrate ahora',
        startSurvey: 'Iniciar encuesta',
        redirectMessage: 'Serás redirigido automáticamente a tu panel en {countDown} segundos...',
        edit: 'Editar',
        delete: 'Eliminar',
        likeThisPost: 'Me gusta esta publicación',
        upVoteThisPost: 'Votar a favor de esta publicación',
        saveAndClose: 'Guardar y cerrar',
        close: 'Cerrar',
        cancel: 'Cancelar',
        editingMessage: 'Editando mensaje',
        showMore: 'Mostrar más',
        showLess: 'Mostrar menos',
        option: 'Opción',
        percentage: 'Porcentaje',
        count: 'Recuento',
        label: 'Etiqueta',
        pleaseSelectAnswer: 'Por favor selecciona una respuesta',
        pleaseSpecify: 'Por favor especifique',
        enterEmail: 'Introduce tu correo electrónico aquí',
        enterNumber: 'Introduce un número aquí',
        enterPhone: 'Introduce un número de teléfono aquí',
        mediaAppearsHere: 'Los medios aparecerán aquí una vez cargados',
        takePart: 'Participar',
        continue: 'Continuar',
        view: 'Ver',
        sendWhatsAppInvite: 'Enviar invitación de WhatsApp',
        currentlyUnavailable: 'Actualmente no disponible',
        seeWhatsApp: 'Ver WhatsApp',
        viewFinalResults: 'Ver resultados finales',
        draft: 'Borrador',
        upNext: 'A continuación',
        completed: 'Completado',
        forum: 'Foro',
        pinnedToDashboard: 'Este foro está fijado en el panel de participantes',
        newLabel: 'Nuevo',
        aiAnalysisEnabled: 'Análisis IA habilitado',
        partOfSequence: 'Parte de una secuencia',
        dateClosed: 'Fecha de cierre:',
        participants: 'Participantes',
        noMobileNumber: 'No se encontró número de móvil, por favor añade uno en la configuración',
        viewResults: 'Ver resultados',
        days: 'días',
        remaining: 'restantes',
        notStarted: 'No iniciado',
        inProgress: 'En progreso',
        closed: 'Cerrado',
        fieldRequired: 'Este campo es obligatorio',
        error: 'Error',
        checkAllQuestionsBeforeProceed: 'Comprueba que has respondido a todas las preguntas antes de intentar continuar.',
        whatsAppIntro: "Hola Mike, gracias por aceptar participar en nuestra actividad de investigación, {projectName} para {accountName}. Por favor responde 'Y' a este mensaje para comenzar y te enviaremos más detalles."
    },
    tr: {
        enterYourTextHere: 'Metninizi buraya girin',
        loading: 'Yükleniyor',
        loadingPage: 'Sayfa yükleniyor...',
        previous: 'Önceki',
        next: 'Sonraki',
        fetchingSurvey: 'Anket alınıyor...',
        completingSurvey: 'Anket tamamlanıyor...',
        registerNow: 'Şimdi kaydol',
        startSurvey: 'Ankete başla',
        redirectMessage: '{countDown} saniye içinde otomatik olarak kontrol panelinize yönlendirileceksiniz...',
        edit: 'Düzenle',
        delete: 'Sil',
        likeThisPost: 'Bu gönderiyi beğen',
        upVoteThisPost: 'Bu gönderiye oy ver',
        saveAndClose: 'Kaydet ve kapat',
        close: 'Kapat',
        cancel: 'İptal',
        editingMessage: 'Mesaj düzenleniyor',
        showMore: 'Daha fazla göster',
        showLess: 'Daha az göster',
        option: 'Seçenek',
        percentage: 'Yüzde',
        count: 'Sayı',
        label: 'Etiket',
        pleaseSelectAnswer: 'Lütfen bir cevap seçin',
        pleaseSpecify: 'Lütfen belirtin',
        enterEmail: 'E-posta adresini buraya girin',
        enterNumber: 'Bir sayı girin',
        enterPhone: 'Telefon numarasını buraya girin',
        mediaAppearsHere: 'Medya yüklendikten sonra burada görünecek',
        takePart: 'Katıl',
        continue: 'Devam et',
        view: 'Görüntüle',
        sendWhatsAppInvite: 'WhatsApp daveti gönder',
        currentlyUnavailable: 'Şu anda kullanılamıyor',
        seeWhatsApp: 'WhatsApp’ı gör',
        viewFinalResults: 'Sonuçları görüntüle',
        draft: 'Taslak',
        upNext: 'Sırada',
        completed: 'Tamamlandı',
        forum: 'Forum',
        pinnedToDashboard: 'Bu forum katılımcı panosuna sabitlendi',
        newLabel: 'Yeni',
        aiAnalysisEnabled: 'Yapay zeka analizi etkin',
        partOfSequence: 'Bir dizinin parçası',
        dateClosed: 'Kapanış tarihi:',
        participants: 'Katılımcılar',
        noMobileNumber: 'Mobil numara bulunamadı, lütfen ayarlardan ekleyin',
        viewResults: 'Sonuçları gör',
        days: 'gün',
        remaining: 'kalan',
        notStarted: 'Başlanmadı',
        inProgress: 'Devam ediyor',
        closed: 'Kapandı',
        fieldRequired: 'Bu alan gereklidir',
        error: 'Hata',
        checkAllQuestionsBeforeProceed: 'Devam etmeden önce tüm soruları yanıtladığınızdan emin olun.',
        whatsAppIntro: "Merhaba Mike, araştırma etkinliğimize katılmayı kabul ettiğin için teşekkürler, {projectName} için {accountName}. Başlamak için lütfen bu mesaja 'Y' yanıtı ver, daha fazla ayrıntıyı göndereceğiz."
    },
    ar: {
        enterYourTextHere: 'أدخل النص هنا',
        loading: 'جارٍ التحميل',
        loadingPage: 'جارٍ تحميل الصفحة...',
        previous: 'السابق',
        next: 'التالي',
        fetchingSurvey: 'جارٍ جلب الاستبيان...',
        completingSurvey: 'جارٍ إكمال الاستبيان...',
        registerNow: 'سجّل الآن',
        startSurvey: 'بدء الاستبيان',
        redirectMessage: 'سيتم إعادة توجيهك تلقائيًا إلى لوحة التحكم خلال {countDown} ثوانٍ...',
        edit: 'تعديل',
        delete: 'حذف',
        likeThisPost: 'أعجبني هذا المنشور',
        upVoteThisPost: 'التصويت لصالح هذا المنشور',
        saveAndClose: 'حفظ وإغلاق',
        close: 'إغلاق',
        cancel: 'إلغاء',
        editingMessage: 'تعديل الرسالة',
        showMore: 'عرض المزيد',
        showLess: 'عرض أقل',
        option: 'خيار',
        percentage: 'النسبة المئوية',
        count: 'العدد',
        label: 'التسمية',
        pleaseSelectAnswer: 'يرجى اختيار إجابة',
        pleaseSpecify: 'يرجى التحديد',
        enterEmail: 'أدخل عنوان البريد الإلكتروني هنا',
        enterNumber: 'أدخل الرقم هنا',
        enterPhone: 'أدخل رقم الهاتف هنا',
        mediaAppearsHere: 'ستظهر الوسائط هنا بعد الرفع',
        takePart: 'شارك',
        continue: 'متابعة',
        view: 'عرض',
        sendWhatsAppInvite: 'إرسال دعوة واتساب',
        currentlyUnavailable: 'غير متاح حاليًا',
        seeWhatsApp: 'عرض واتساب',
        viewFinalResults: 'عرض النتائج النهائية',
        draft: 'مسودة',
        upNext: 'التالي',
        completed: 'مكتمل',
        forum: 'منتدى',
        pinnedToDashboard: 'هذا المنتدى مثبت على لوحة تحكم المشارك',
        newLabel: 'جديد',
        aiAnalysisEnabled: 'تحليل الذكاء الاصطناعي مفعّل',
        partOfSequence: 'جزء من سلسلة',
        dateClosed: 'تاريخ الإغلاق:',
        participants: 'المشاركون',
        noMobileNumber: 'لم يتم العثور على رقم هاتف محمول، يرجى إضافته في الإعدادات',
        viewResults: 'عرض النتائج',
        days: 'أيام',
        remaining: 'متبقية',
        notStarted: 'لم يبدأ',
        inProgress: 'قيد التقدم',
        closed: 'مغلق',
        fieldRequired: 'هذا الحقل مطلوب',
        error: 'خطأ',
        checkAllQuestionsBeforeProceed: 'يرجى التحقق من أنك أجبت على جميع الأسئلة قبل محاولة المتابعة.',
        whatsAppIntro: "مرحبًا مايك، شكرًا لموافقتك على المشاركة في نشاطنا البحثي {projectName} لصالح {accountName}. يرجى الرد بـ 'Y' على هذه الرسالة للبدء وسنرسل لك المزيد من التفاصيل."
    }
};
